import {
  useRecordContext,
  useNotify,
  useRefresh,
  useDataProvider,
  useRedirect
} from "react-admin";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  CardContent,
  Typography,
  CardMedia,  
  Box,
} from "@mui/material";

const PublicationTab = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const [open, setOpen] = useState(false);
  const redirect = useRedirect();

  const handlePublish = async () => {
    try {      
      await dataProvider.update("courses", {
       id:record.id,
       data:{isPublished:true},  
      });
      notify("Curso publicado correctamente", { type: "success" });
      refresh();
       redirect("list", "courses");
      setOpen(false);
    } catch (error) {
      notify("Error al publicar el curso", { type: "error" });
    }
  };

  const handleOpenPreview = () => setOpen(true);
  const handleClose = (e) =>{
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <>     

      <Button
           variant="contained" size="small" onClick={(e) => {e.stopPropagation();
           setOpen(true);
            }}
            disabled={record.isPublished} // Desactiva si ya está publicado
            >
           Publicar
      </Button>


      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Vista previa del curso</DialogTitle>
        <DialogContent>
          <Card
            sx={{
              mt: 2,
              boxShadow: 6,
              "&:hover": {
                boxShadow: "20px 10px 20px 5px rgba(3, 3, 3, 0.2)",
                transition: "all 0.5s linear",
              },
            }}
          >
            <CardMedia
              component="img"
              height="256"
              image={record.image || "/default-image.jpg"}
              alt={record.title}
              sx={{
                transition: "all 0.5s ease-in-out",
                
              }}
            />
            <CardContent sx={{ fontFamily: "Roboto, sans-serif", padding: "2rem 1rem" }}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.3rem",
                }}
              >
                {record.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1 }}
              >
                {record.description}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Precio: ${record.price}
              </Typography>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handlePublish} variant="contained" color="primary">
            Publicar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PublicationTab;
